import styled from "styled-components";
import { darken } from "polished";

export const MaterialName = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const MaterialColorBox = styled.div<{ $color: string }>`
  border: 1px solid ${(p) => darken(0.1, p.$color)};
  background-color: ${(p) => p.$color};
  width: 0.75rem;
  height: 0.75rem;
  flex-shrink: 0;
  border-radius: 2px;
  margin-right: 0.375rem;
  margin-top: 0.25em;
`;

export const MaterialLabel = styled.span`
  min-width: 0;
`;

export const OptimizationSuffix = styled.span`
  /* Keep the non-breaking space and icon attached to the preceding word. */
  white-space: nowrap;
`;

export const OptimizationIconContainer = styled.div`
  display: inline-block;
  font-size: 0.875rem;
  vertical-align: -0.125em;
  margin-left: 1px;
  color: ${(p) => p.theme.color.brand.blue};

  svg {
    display: block;
  }
`;
